import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

import { useRouter } from '@cvt/routing';

type Props = {
  label: string;
  requiredAnswers: number;
  totalAnswered: number;
};

export const IncompleteStage: React.FC<Props> = ({ label, requiredAnswers, totalAnswered }) => {
  const router = useRouter();
  const remaining = Math.max(0, requiredAnswers - totalAnswered);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { xs: 'calc(100dvh - 220px)' },
      }}
    >
      <Paper elevation={1} sx={{ width: '100%', p: 3, textAlign: 'center' }}>
        <Stack direction="column" spacing={2} alignItems="center" textAlign="center">
          <Typography variant="h6">
            Answer a few more Assertions to understand your {label} matches
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {remaining > 0
              ? `You're ${remaining} answer${remaining === 1 ? '' : 's'} away from unlocking this view.`
              : 'Keep answering to reveal how your choices shaped these matches.'}
          </Typography>
          <Button variant="contained" color="primary" onClick={() => router.home.go()}>
            Start Swiping
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};
